import { useSelector } from 'react-redux'
import AlertMessage from '../layout/AlertMessage'

const ChatUpgradeAlert = ({ visible, minPlan, onViewPlans, onClose }) => {
  const language = useSelector((state) => state.language)
  const translations = useSelector((state) => state.translationsData) || {}

  const getTranslationText = (
    keyPath,
    data = translations,
    lang = language,
  ) => {
    const validLangs = ['EN', 'FR', 'NL', 'SW']
    const normalizedLang = String(lang || 'EN')
      .trim()
      .toUpperCase()
    const selectedLang = validLangs.includes(normalizedLang)
      ? normalizedLang
      : 'EN'

    const keys = keyPath.split('.')
    let result = data
    for (const key of keys) {
      result = result?.[key]
      if (Array.isArray(result)) result = result[0]
    }

    if (result && typeof result === 'object') {
      return result[selectedLang] ?? result.EN ?? 'Text not found'
    }

    return result || 'Text not found'
  }

  const translateText = (keyPath, replacements = {}) => {
    let value = getTranslationText(keyPath)
    if (typeof value === 'string') {
      Object.entries(replacements).forEach(([key, replacement]) => {
        value = value.replace(
          new RegExp(`\\{${key}\\}`, 'g'),
          String(replacement),
        )
      })
    }
    return value
  }

  if (!visible) return null

  return (
    <AlertMessage
      message={translateText('chat.upgradeAlert.title')}
      subtext={translateText('chat.upgradeAlert.subtext', { plan: minPlan })}
      confirmButtonText={translateText('chat.upgradeAlert.button')}
      onConfirm={onViewPlans}
      onCancel={onClose}
    />
  )
}

export default ChatUpgradeAlert
